// extracted by mini-css-extract-plugin
export default {"notaryDetails":"QpGRp_P8sS6VBcW6TlFL"};